






export default {
  name: 'related-tags-list'
};
